import type {Design} from "./_types/Design";
import {convertOldDesignJsonToNewDesignJson} from "./helpers/convertOldDesignJsonToNewDesignJson";
import {getPngChunkData} from "./helpers/png/getPngChunkData";

const PNG_CHUNK_ID = "koEN";

export const readDesignFile = async (
    file: Blob
): Promise<Design> => {

    const png = new Uint8Array(await file.arrayBuffer());

    const designData = getPngChunkData(PNG_CHUNK_ID, png);
    const designString = new TextDecoder()
        .decode(designData)
        .replace(/[\u0000-\u001F]+/g, '')
        .trim();

    const design = JSON.parse(designString);
    convertOldDesignJsonToNewDesignJson(design);

    return {
        ...design,
        images: await Promise.all(design.images.map(loadImage))
    } as Design;
};

const loadImage = (src: string): Promise<HTMLImageElement> => new Promise((resolve, reject) => {
    const image = new Image();
    image.src = src;
    image.onerror = reject;
    image.onload = () => resolve(image);
});